import React from 'react';
import styled from '@emotion/styled';
import { BLACK, GRAY } from '../../../styles/constants/color';
import { fontFrame } from '../../../styles/mixin/font';

const InputElement = styled.input<{
  width: string;
  height: string;
  fontWeight: string;
  fontSize: string;
  lineHeight: string;
  color: string;
  inputTextAlign: string;
}>`
  width: ${props => props.width};
  height: ${props => props.height};
  border: 1px solid ${GRAY};
  ${props => fontFrame(props.fontWeight, props.fontSize, props.lineHeight, props.color)};
  text-align: ${props => props.inputTextAlign};
  padding: 0 4px;
`;

interface Props {
  type?: string;
  width?: string;
  height?: string;
  name: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: () => void;
  value: number | string;
  fontWeight?: string;
  fontSize?: string;
  lineHeight?: string;
  color?: string;
  textAlign?: string;
  placeholder?: string;
  isDisabled?: boolean;
  maxLength?: number;
}

/**
 *  input 공통 컴포넌트
 * @param {string} type input의 type (default: text)
 * @param {string} width input의 width (default: 65px)
 * @param {string} height input의 height (default: 25px)
 * @param {string} name input의 name
 * @param {function} onChange onChange 이벤트
 * @param {function} onBlur onBlur 이벤트
 * @param {number | string} value input의 value
 * @param {string} fontWeight input의 fontWeight '400', Medium, Bold (default: '400')
 * @param {string} fontSize input의 fontSize (defalut: 13px)
 * @param {string} lineHeight input의 lineHeight (default: 1)
 * @param {string} color input의 color (default: #222)
 * @param {string} textAlign input의 text-align (default: right)
 * @param {string} placeholder input의 placeholder (default: '')
 * @param {boolean} isDisabled input의 disabled (default: false)
 * @param {number} maxLength input의 maxLength (default: 999999999)
 *  */
function Input({
  type = 'text',
  width = '65px',
  height = '25px',
  name,
  onChange,
  onBlur,
  value = '',
  fontWeight = '400',
  fontSize = '13px',
  lineHeight = '1',
  color = BLACK,
  textAlign = 'right',
  placeholder = '',
  isDisabled = false,
  maxLength = 999999999,
}: Props): JSX.Element {
  return (
    <InputElement
      type={type}
      width={width}
      height={height}
      name={name}
      onChange={onChange}
      onBlur={() => {
        onBlur && onBlur();
      }}
      onClick={(e: React.MouseEvent<HTMLInputElement>) => e.stopPropagation()}
      value={value}
      fontWeight={fontWeight}
      fontSize={fontSize}
      lineHeight={lineHeight}
      color={color}
      inputMode={type === 'number' ? 'numeric' : undefined}
      inputTextAlign={textAlign}
      placeholder={placeholder}
      disabled={isDisabled}
      maxLength={maxLength}
    />
  );
}

export default Input;
